import { CountryOptionList as e } from "./base/CountryOptionList.js";
import { useEffect as t, useState as n } from "react";
import { Button as r, ResponsiveDialog as i } from "@sprd/sprd-component-kit/v2";
import a from "clsx";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
//#region src/components/CountrySelector/CountrySelectorDialog.tsx
function c({ open: c, onOpenChange: l, countries: u, value: d, onChange: f, title: p, closeLabel: m, updateLabel: h, className: g }) {
	let [_, v] = n(d);
	return t(() => {
		c && v(d);
	}, [c, d]), /* @__PURE__ */ o(i, {
		dismissible: !0,
		open: c,
		onOpenChange: l,
		title: p,
		closeLabel: m,
		className: a("sm:max-w-[34.625rem]", g),
		children: /* @__PURE__ */ s("div", {
			className: "flex flex-col",
			children: [/* @__PURE__ */ o(e, {
				countries: u,
				value: _,
				onSelect: v,
				label: p,
				className: "flex flex-col px-4 md:px-8"
			}), /* @__PURE__ */ o("div", {
				className: "sticky bottom-0 border-t border-neutral-300 bg-white p-4 md:px-8 md:pt-4 md:pb-8",
				children: /* @__PURE__ */ o(r, {
					variant: "primary",
					size: "l",
					className: "w-full",
					onClick: () => f(_),
					children: h
				})
			})]
		})
	});
}
//#endregion
export { c as CountrySelectorDialog };
